import moment from 'moment';

export const getRemainingTimeToMidnightUTC = (): string => {
  const { hours, minutes } = getHoursAndMinutesToMidnightUTC();

  let remainingHours = '';
  if (hours === 1) {
    remainingHours = `1 hr `;
  } else if (hours > 1) {
    remainingHours = `${hours} hrs `;
  }

  const remainingMinutes = minutes === 0 ? '1 min' : `${minutes} min`;

  return remainingHours + remainingMinutes;
};

const getHoursAndMinutesToMidnightUTC = (): {
  hours: number;
  minutes: number;
} => {
  const nextMidnightUTC = moment().utc().add(1, 'days').startOf('day');
  const nowUTC = moment().utc();
  const duration = moment.duration(nextMidnightUTC.diff(nowUTC));

  const hours = duration.hours();
  const minutes = duration.minutes();

  return { hours, minutes };
};
